import useNavigationHistory from "../hooks/useNavigationHistory"

const NavHistoryTracker = ({title}: {title?: string}) => {
  useNavigationHistory(title);
  return null;
}

export default NavHistoryTracker;